"use strict";var e=require("../OPMContext-cjs-D0SJ7si-.js");require("react"),require("react/jsx-runtime"),exports.OPMProvider=e.O,exports.UseOPMContext=e.U;